const SCRIPT_SRC = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'

let loadPromise: Promise<void> | null = null

export function loadAppleScript(clientId: string): Promise<void> {
    if (loadPromise) return loadPromise

    loadPromise = new Promise((resolve, reject) => {
        const existing = document.querySelector(`script[src="${SCRIPT_SRC}"]`)
        if (existing) {
            AppleID.auth.init({
                clientId,
                scope: 'name email',
                redirectURI: window.location.origin,
                usePopup: true,
            })
            resolve()
            return
        }

        const script = document.createElement('script')
        script.src = SCRIPT_SRC
        script.async = true
        script.defer = true
        script.onload = () => {
            AppleID.auth.init({
                clientId,
                scope: 'name email',
                redirectURI: window.location.origin,
                usePopup: true,
            })
            resolve()
        }
        script.onerror = () => reject(new Error('Failed to load Apple Sign In SDK'))
        document.head.appendChild(script)
    })

    return loadPromise
}

declare global {
    const AppleID: {
        auth: {
            init(config: {
                clientId: string
                scope: string
                redirectURI: string
                usePopup: boolean
            }): void
            signIn(): Promise<{
                authorization: {
                    code: string
                    id_token: string
                    state?: string
                }
                user?: {
                    name?: { firstName?: string; lastName?: string }
                    email?: string
                }
            }>
        }
    }
}
